export const REPORT_ROUTE_NAMES = {
  OVERVIEW: 'reportsOverview',
  SALES: 'reportSales',
} as const
